import {mapActions, mapGetters} from "vuex";

export default {
    props: ['orderData'],
    data(){
      return{
          templateText:'',
          activeTemplate:0,
          prevActiveTemplate:0,
          receiptUrl:'',
          receiptUrlSale:'',
          receiptUrlReturn:'',
          receiptsLoaded:false,
          textTemplateList:[
              {
                  template:'{order_id}',
                  text:''
              },
              {
                  template:'{buyer_fio}',
                  text:''
              },
              {
                  template:'{buyer_f}',
                  text:''
              },
              {
                  template:'{buyer_i}',
                  text:''
              },
              {
                  template:'{buyer_o}',
                  text:''
              },
              {
                  template:'{total}',
                  text:''
              },
              {
                  template:'{products}',
                  text:''
              },
              {
                  template:'{ttn}',
                  text:''
              },
              {
                  template:'{receipt_url}',
                  text:''
              },
              {
                  template:'{{receipt_url}}',
                  text:''
              },
              {
                  template:'{receipt_url_sale}',
                  text:''
              },
              {
                  template:'{receipt_url_return}',
                  text:''
              },
          ]
      }
    },
    computed:{
      ...mapGetters({
          smsTemplates:'templates/smsTemplates',
          smsBalance:'templates/smsBalance',
      })
    },
    watch:{
        templateText(){
            this.validateText()
        }
    },
    created() {
        this.getSmsTemplates();
        this.getDataForTextTemplates();
        this.getSmsBalance();
        this.loadReceiptUrl();
    },
    methods:{
        sendSMS(){
            const payload = {
                "phone": "38"+this.orderData.phone,
                "text" : this.templateText,
                "id":this.orderData.id,
            }
            this.sendSMSTemplate(payload).then(res=>{
                if(res.result){
                    this.$toasted.success(this.$t('popupSendSms.sent'), {
                        duration: 3000,
                    })
                    this.closePopup();
                }else {
                    this.$toasted.error(res.data, {
                        duration: 3000,
                    })
                }
            })

        },
        showActiveTemplate(id){
            let activeTemplate = this.smsTemplates.data.filter(item=>item.id === id)
            activeTemplate = activeTemplate[0];
            this.changeActiveTemplate(activeTemplate)
        },
        getActiveTemplate(item){
            this.prevActiveTemplate = item.id
        },
        changeActiveTemplate(item){
            this.activeTemplate = item.id;
            this.templateText = item.text
        },
        validateText(){
            const sorted = [...this.textTemplateList].sort((a, b) => b.template.length - a.template.length);
            sorted.map(item=>{
                if(this.templateText.includes(item.template)){
                    if (this.isReceiptTemplate(item.template) && !this.receiptsLoaded) {
                        return;
                    }
                    this.templateText = this.templateText.split(item.template).join(item.text);
                }
            })
        },
        isReceiptTemplate(template){
            return template === '{receipt_url}'
                || template === '{{receipt_url}}'
                || template === '{receipt_url_sale}'
                || template === '{receipt_url_return}';
        },
        closePopup(){
            this.$emit('closePopup');
        },
        getDataForTextTemplates(){
            const customerName = this.orderData.customer_name.split(' ');
            let price = 0;
            let products = 0;
            this.orderData.products.map(item=>{
                price += item.price * item.quantity;
                products += item.title + ', ';
            })
            this.textTemplateList.map(item=>{
                if(item.template === '{order_id}'){item.text = this.orderData.order_id ? this.orderData.order_id : ''}
                else if(item.template === '{buyer_fio}'){item.text = this.orderData.customer_name ? this.orderData.customer_name : ''}
                else if(item.template === '{buyer_f}'){item.text = customerName[0] ? customerName[0] : ''}
                else if(item.template === '{buyer_i}'){item.text = customerName[1] ? customerName[1] : ''}
                else if(item.template === '{buyer_o}'){item.text = customerName[2] ? customerName[2] : ''}
                else if(item.template === '{total}'){item.text = price ? price : 0}
                else if(item.template === '{products}'){item.text = products ? products : ''}
                else if(item.template === '{ttn}'){item.text = this.orderData.ttn ? this.orderData.ttn : ''}
                else if(item.template === '{receipt_url}'){item.text = this.receiptUrl}
                else if(item.template === '{{receipt_url}}'){item.text = this.receiptUrl}
                else if(item.template === '{receipt_url_sale}'){item.text = this.receiptUrlSale}
                else if(item.template === '{receipt_url_return}'){item.text = this.receiptUrlReturn}
            })
        },
        loadReceiptUrl(){
            if (this.orderData && this.orderData.id) {
                this.getReceiptsByOrder(this.orderData.id).then(res => {
                    this.receiptsLoaded = true;
                    if (res.status && res.data && res.data.length) {
                        const sortedReceipts = res.data.sort((a, b) => 
                            new Date(b.created_at) - new Date(a.created_at)
                        );
                        const latestReceipt = sortedReceipts[0];
                        this.receiptUrl = latestReceipt.receipt_url || '';
                        const saleReceipt = sortedReceipts.find(item => item.type === 'sale' && item.receipt_url);
                        const returnReceipt = sortedReceipts.find(item => item.type === 'return' && item.receipt_url);
                        this.receiptUrlSale = saleReceipt ? saleReceipt.receipt_url : '';
                        this.receiptUrlReturn = returnReceipt ? returnReceipt.receipt_url : '';
                        this.textTemplateList.forEach(item => {
                            if (item.template === '{receipt_url}' || item.template === '{{receipt_url}}') {
                                item.text = this.receiptUrl;
                            } else if (item.template === '{receipt_url_sale}') {
                                item.text = this.receiptUrlSale;
                            } else if (item.template === '{receipt_url_return}') {
                                item.text = this.receiptUrlReturn;
                            }
                        });
                        this.validateText();
                    } else {
                        this.receiptUrl = '';
                        this.receiptUrlSale = '';
                        this.receiptUrlReturn = '';
                        this.textTemplateList.forEach(item => {
                            if (this.isReceiptTemplate(item.template)) {
                                item.text = '';
                            }
                        });
                        this.validateText();
                    }
                });
            }
        },
        ...mapActions({
            getSmsTemplates:'templates/getSmsTemplates',
            getSmsBalance:'templates/getSmsBalance',
            sendSMSTemplate:'templates/sendSMSTemplate',
            getReceiptsByOrder:'checkbox/getReceiptsByOrder',
        })
    }
}
